import { render, staticRenderFns } from "./BAVideoStudio.vue?vue&type=template&id=67e29397&scoped=true&"
import script from "./BAVideoStudio.vue?vue&type=script&lang=ts&"
export * from "./BAVideoStudio.vue?vue&type=script&lang=ts&"
import style0 from "./BAVideoStudio.vue?vue&type=style&index=0&id=67e29397&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67e29397",
  null
  
)

export default component.exports